import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  ["Element", "Daily Sale", { role: "style" }],
  ["Mon", 8.94, "#b87333"], // RGB value
  ["Tue", 10.49, "silver"], // English color name
  ["Wed", 19.3, "gold"],
  ["Thu", 21.45, "color: #e5e4e2"], // CSS-style declaration
  ["Fri", 19.3, "gold"],
  ["Sat", 19.3, "#e5e4e2"],
  ["Sun", 19.3, "gold"],
];

export function BarChart() {
  return (
    <Chart chartType="ColumnChart" width="100%" height="400px" data={data} />
  );
}
